// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginFormPage_wrapper__ncgtS","form":"LoginFormPage_form__sP1cI"};